import { useNavigate, useLocation } from "react-router-dom";

const Admin = ({ isToggled, toggleSidebar }: { isToggled?: boolean, toggleSidebar?: () => void }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    {
      name: 'Dashboard',
      navigateTo: '',
      icon: 'fa-border-all',
      mobileBg: '#e8f0fe',
      mobileColor: '#4285f4'
    },
    {
      name: 'Customers',
      navigateTo: 'customer',
      icon: 'fa-users',
      mobileBg: '#fce8e6',
      mobileColor: '#ea4335'
    },
    {
      name: 'Properties',
      navigateTo: 'property',
      icon: 'fa-home',
      mobileBg: '#e6f4ea',
      mobileColor: '#34a853'
    },
    {
      name: 'Banners',
      navigateTo: 'custom-ad',
      icon: 'fa-image',
      mobileBg: '#fef7e0',
      mobileColor: '#fbbc04'
    },
    {
      name: 'Leads / Appointments',
      navigateTo: 'appointments',
      icon: 'fa-calendar-check',
      mobileBg: '#f3e8fd',
      mobileColor: '#9334e6'
    },
  ];

  return (
    <ul
      className={`navbar-nav bg-primary sidebar sidebar-dark accordion ${isToggled ? 'toggled' : ''}`}
      id="accordionSidebar"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      {/* Sidebar - Brand */}
      <div className="sidebar-brand d-flex align-items-center justify-content-between px-3 w-100 mt-2 mb-3" style={{ height: '4.375rem' }}>
        <a className="d-flex align-items-center text-white text-decoration-none w-100" href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
          <div className="sidebar-brand-icon mr-2 bg-white text-primary rounded-circle d-flex align-items-center justify-content-center shadow-sm" style={{ width: '40px', height: '40px' }}>
            <i className="fas fa-laugh-wink fa-lg"></i>
          </div>
          <div className="sidebar-brand-text d-flex flex-column align-items-start justify-content-center">
            <span style={{ fontSize: '1.25rem', fontWeight: '800', lineHeight: '1.2' }}>Cirayedaar</span>
            <span style={{ fontSize: '0.65rem', fontWeight: '600', letterSpacing: '1px', opacity: 0.8 }}>ADMIN</span>
          </div>
        </a>
        {toggleSidebar && (
          <button className="btn btn-link text-white d-md-none p-0 border-0" onClick={toggleSidebar}>
            <i className="fas fa-times fa-lg"></i>
          </button>
        )}
      </div>

      <hr className="sidebar-divider my-0 d-none d-md-block mb-3" />

      {/* Mobile Title - Only visible on small screens */}
      <div className="mobile-title px-4 pt-2 pb-4 d-md-none">
        <h2 className="fw-bolder mb-2" style={{ color: '#1a202c', fontSize: '1.8rem' }}>How can we help?</h2>
        <p className="text-muted" style={{ fontSize: '0.95rem', lineHeight: '1.4' }}>
          Select an option below to manage the platform and view insights.
        </p>
      </div>

      <li className="nav-item active w-100">
        {
          items.map(item => {
            const isActive = location.pathname === `/${item.navigateTo}` || (item.navigateTo === '' && location.pathname === '/');
            return (
              <button
                key={item.name}
                type="button"
                className="nav-link collapsed mobile-grid-btn"
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 20px',
                  margin: '4px 16px',
                  borderRadius: '10px',
                  color: 'white',
                  opacity: isActive ? 1 : 0.8,
                  backgroundColor: isActive ? 'rgba(255,255,255,0.2)' : 'transparent',
                  width: 'calc(100% - 32px)',
                  transition: 'all 0.2s ease-in-out'
                }}
                onClick={() => {
                  navigate(`/${item.navigateTo}`);
                  if (window.innerWidth <= 768 && toggleSidebar) {
                    toggleSidebar();
                  }
                }}
                onMouseEnter={(e) => {
                  if (!isActive) e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
                }}
                onMouseLeave={(e) => {
                  if (!isActive) e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <div className="icon-wrapper" style={{ backgroundColor: item.mobileBg, color: item.mobileColor }}>
                  <i className={`fas ${item.icon}`}></i>
                </div>
                <span style={{ fontSize: '0.95rem', fontWeight: isActive ? '600' : '500' }}>{item.name}</span>
              </button>
            )
          })
        }
      </li>

      <hr className="sidebar-divider d-none d-md-block mt-3" />

      <div className="mt-auto p-3 mb-4 w-100 d-none d-md-block">
        <button 
          className="btn btn-success w-100 shadow d-flex align-items-center justify-content-center font-weight-bold"
          style={{ borderRadius: '8px', padding: '12px', backgroundColor: '#1cc88a', border: 'none' }}
          onClick={() => navigate('/property')}
        >
          <i className="fas fa-plus mr-2"></i> Add Property
        </button>
      </div>

      <div className="text-center d-none d-md-inline mb-3">
        <button className="rounded-circle border-0" onClick={toggleSidebar}></button>
      </div>
    </ul>
  );
};

export default Admin;
